"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderEntity = void 0;

var framework_1 = require("../core/framework");

var _1 = require(".");

var enums_1 = require("../enums");

var OrderEntity =
/** @class */
function (_super) {
  __extends(OrderEntity, _super);

  function OrderEntity() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(OrderEntity.prototype, "id", {
    get: function get() {
      return Number(this.entity.id || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "placedAt", {
    get: function get() {
      return new Date(this.entity.placedAt || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "status", {
    get: function get() {
      return enums_1.OrderStatus[this.entity.status] || enums_1.OrderStatus.UNKNOWN;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "totalPrice", {
    get: function get() {
      return Number(this.entity.totalPrice || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "subtotalPrice", {
    get: function get() {
      return Number(this.entity.subtotalPrice || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "originSubtotalPrice", {
    get: function get() {
      return Number(this.entity.originSubtotalPrice || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "discount", {
    get: function get() {
      return Number(this.entity.discount || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "promotions", {
    get: function get() {
      return (this.entity.promotions || []).map(function (promotion) {
        return new _1.OrderPromotionEntity(promotion);
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "skus", {
    get: function get() {
      return (this.entity.skus || []).map(function (sku) {
        return new _1.OrderSkuEntity(sku);
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "taxes", {
    get: function get() {
      return (this.entity.taxes || []).map(function (tax) {
        return new _1.OrderTaxEntity(tax);
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "depotId", {
    get: function get() {
      return Number(this.entity.depotId || 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "checkpoint", {
    get: function get() {
      return new _1.CheckpointEntity(this.entity.checkpoint);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(OrderEntity.prototype, "isPacked", {
    get: function get() {
      return Boolean(this.entity.isPacked);
    },
    enumerable: false,
    configurable: true
  });
  return OrderEntity;
}(framework_1.Entity);

exports.OrderEntity = OrderEntity;